<h2>Home</h2>

<div *ngIf="pleaseLogin" style="text-align: center">
  <button class="btn btn-primary" routerLink="/login">Login</button>
</div>
